function campaignAnalyticsOptions() {
  const target = document.querySelector('#campaign_message')

  if (!target) return

  const apiPath = target.dataset.campaignAnalyticsPath
  const resourceName = 'campaign_analytics'
  const params = {
    campaign_id: target.dataset.campaignId
  }

  return {
    target,
    options: {
      apiPath,
      resourceName,
      params
    }
  }
}

export default campaignAnalyticsOptions